export class ParticipantDTOResponse {
  id: number;
  companyId: number;
  cpfCNPJParticipant: string;
  name: string;
  ie: string;
  autoGenerated: boolean;
  accountId: number;
}
